import { createSlice } from '@reduxjs/toolkit';

const inviteLinkSlice = createSlice({
  name: 'inviteLink',
  initialState: {
    link: null,
  },
  reducers: {
    setInviteLink: (state, action) => {
      state.link = action.payload;
    },
    clearInviteLink: (state) => {
      state.link = null;
    },
  },
});

export const { setInviteLink, clearInviteLink } = inviteLinkSlice.actions;

export default inviteLinkSlice.reducer;
